// extracted by mini-css-extract-plugin
export var backdropBlur = "_64-0";
export var body = "_64-5";
export var bodyScroll = "_64-6";
export var columnFooter = "_64-7";
export var contentColumn = "_64-4";
export var frame = "_64-3";
export var heroContent = "_64-b";
export var heroOverlay = "_64-a";
export var image = "_64-9";
export var imageWrapper = "_64-8";
export var modal = "_64-1";
export var modalMain = "_64-2";
export var productHeader = "_64-c";
export var productHeaderIcon = "_64-d";
export var productHeaderName = "_64-e";
export var progressIndicator = "_64-f";